<template>
  <ContentBanner
    variant="incomplete"
    icon="docs"
    title="Pending Signature"
    primary-label="Send Reminder"
  >
    <p class="text-body-3 text-textLight mb-0">
      This employee has had an acknowledgement pending for <strong>{{ daysPending }}</strong> days.
      <a
        href="https://help.datapeople.io/article/342-acknowledgements-slas"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary text-decoration-none cursor-pointer"
        @click.stop
      >Read more here.</a>
    </p>
    <template #actions>
      <DpplDarkTooltip
        v-if="!canSendReminder"
        tooltip-placement="bottom"
        light-mode
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <span
            class="banner-action-disabled-wrapper"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <v-btn
              color="brandPrimary"
              variant="flat"
              size="small"
              disabled
            >
              Send Reminder
            </v-btn>
          </span>
        </template>
        <template #tooltip-content>
          <p class="text-body-2 text-textDark">
            {{ sendReminderDisabledTooltip }}
          </p>
        </template>
      </DpplDarkTooltip>
      <v-btn
        v-else
        color="brandPrimary"
        variant="flat"
        size="small"
        @click="emit('send-reminder')"
      >
        Send Reminder
      </v-btn>
      <v-btn
        variant="outlined"
        size="small"
        color="error"
        class="content-banner-secondary-btn content-banner-secondary-btn-error"
        @click="emit('cancel')"
      >
        Cancel
      </v-btn>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  daysPending: { type: Number, default: 0 },
  canSendReminder: { type: Boolean, default: true },
  sendReminderDisabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['send-reminder', 'cancel']);
</script>

<style scoped lang="less">
.banner-action-disabled-wrapper {
  display: inline-block;
}
</style>
